import React from 'react';

/**
 * Hook to refresh current page by calling window.location.reload().
 */
const useReloadPage = () => {
  const [isReloading, setIsReloading] = React.useState(false);
  const reload = () => {
    window.location.reload();
    setIsReloading(true);
  };

  return {
    isReloading,
    reload,
  };
};

export { useReloadPage };
